import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

import * as React from "react";
import { useEffect, useState } from "react";

const SingleRadio = ({
  data,
  header,
  setFilters,
  filters,
  customFieldName,
  boolTitles,
}: {
  data: Record<string, any>[];
  header: string;
  filters: Record<string, any>;
  setFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  customFieldName?: string;
  boolTitles: string[];
}) => {
  // Initialize value from filters
  const [value, setValue] = useState<string>(() => {
    const filterValue = filters[header]?.keywords;
    if (filterValue === undefined) return "";
    return String(filterValue);
  });

  useEffect(() => {
    // Update value when filters change
    if (!filters[header]) {
      setValue("");
    } else {
      const filterValue = filters[header]?.keywords;
      if (filterValue !== undefined) {
        setValue(String(filterValue));
      }
    }
  }, [filters, header]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setValue(selectedValue);
    
    // Update parent filters without triggering API call
    setFilters((prev) => ({
      ...prev,
      [header]: {
        comparator: "only",
        keywords: selectedValue, // Keep original case
      },
    }));
  };

  return (
    <FormControl>
      <FormLabel id={`${header}-radio-group-label`}>
        {customFieldName ?? header}
      </FormLabel>
      <RadioGroup
        aria-labelledby={`${header}-radio-group-label`}
        name={`${header}-radio-group`}
        value={value}
        onChange={handleChange}
      >
        {boolTitles.map((title) => (
          <FormControlLabel
            key={title}
            value={title}
            control={<Radio />}
            label={title}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default SingleRadio;
